module.exports = __webpack_public_path__ + "static/media/stand_02.d701f18b.usdz";